var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg678Ad5246Dc2364010C1D6529D0Cf2Da(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.575V22.575H18V25.575H0ZM0 9.57499V6.57499H18V9.57499H0ZM24.4 31.725L22.3 29.625L27.9 24.075L22.3 18.525L24.4 16.425L30 21.975L35.55 16.425L37.65 18.525L32.1 24.075L37.65 29.625L35.55 31.725L30 26.175L24.4 31.725ZM29.1 13.375L22.3 6.57499L24.4 4.47499L29.05 9.12499L37.9 0.274994L40 2.42499L29.1 13.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg678Ad5246Dc2364010C1D6529D0Cf2Da);
export default __webpack_public_path__ + "static/media/678ad5246dc2364010c1d6529d0cf2da.25f50cbdda1edbbe69faf41e01909c51.svg";
export { ForwardRef as ReactComponent };